import React, { Component } from 'react';
import { FormModalContainer, CloseIconContainer } from '../style';
import { connect } from 'react-redux';
import { Text } from '../../../UI/Text';
import { Loading } from '../../../Containers/WithLoading/Loading';
import { UserRow } from '../../Rows/UserRow/UserRow';
import { TrainerContent } from './style';
import { SearchInput, UsersContainer } from '../AddMemberModal/style';
import { EmptyState } from '../../../Containers/WithEmptyState/EmptyState';
import { UsersEmptyState } from '../../BannerEmptyStats/BannerEmptyStats';
import InfiniteUsersSearch from '../AddMemberModal/InfiniteUsersSearch';
import debounce from 'lodash.debounce';
import { SearchUsersActionCreators } from '../../../../Store/ActionCreators/SearchUsersActionCreators';

class AddTrainerModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchFilter: '',
        };
    }

    componentDidMount() {
        this.props.getSearchUsers(this.state.searchFilter);
    }

    handleAddTrainer = trainer => {
        this.props.addTrainer(trainer);
    };

    handleChange = e => {
        this.setState({ searchFilter: e.target.value }, () => this.searchWithDelay());
    };

    searchWithDelay = debounce(() => {
        this.props.getSearchUsers(this.state.searchFilter);
    }, 250);

    render() {
        const { onClose, users, loading } = this.props;
        const { searchFilter } = this.state;

        return (
            <FormModalContainer>
                <TrainerContent>
                    <Text alignCenter marginBottom={'30px'} fontSize={22} weight={'bold'}>
                        Add Trainer
                    </Text>
                    <SearchInput onChange={this.handleChange} placeholder={'Search among Tona users'} />

                    <UsersContainer id={'add-trainer-modal-scroll'}>
                        <Loading isLoading={loading}>
                            <EmptyState isEmpty={users.length === 0} emptyState={UsersEmptyState}>
                                <InfiniteUsersSearch
                                    scrollableTarget={'add-trainer-modal-scroll'}
                                    filter={searchFilter}
                                >
                                    {users.map((user, index) => (
                                        <UserRow key={index} onAdd={this.handleAddTrainer} user={user} />
                                    ))}
                                </InfiniteUsersSearch>
                            </EmptyState>
                        </Loading>
                        <CloseIconContainer onClick={onClose}>
                            <i className="fas fa-times" />
                        </CloseIconContainer>
                    </UsersContainer>
                </TrainerContent>
            </FormModalContainer>
        );
    }
}

const mapStateToProps = ({ usersSearch: { users, loading } }) => ({
    users,
    loading,
});

const mapDispatchToProps = dispatch => ({
    getSearchUsers: filter => dispatch(SearchUsersActionCreators.getUsers(filter)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddTrainerModal);



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddTrainerModal/AddTrainerModal.js